import { render, staticRenderFns } from "./authConfig.vue?vue&type=template&id=2db994b6&scoped=true"
import script from "./authConfig.vue?vue&type=script&lang=js"
export * from "./authConfig.vue?vue&type=script&lang=js"
import style0 from "./authConfig.vue?vue&type=style&index=0&id=2db994b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db994b6",
  null
  
)

export default component.exports